
<div *ngIf="!hasFile">
  <span class="delivery-note-label" *ngIf="showLabel">{{ 'delivery-note.delivery-note_section_title' | translate }}</span>
  <button
    type="button"
    class="dn-add-button"
    [ngClass]="{ 'full-width': fullWidth }"
    (click)="onUpload()"
    [disabled]="isLoading"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="17 8 12 3 7 8"></polyline>
      <line x1="12" y1="3" x2="12" y2="15"></line>
    </svg>
    <span class="dn-add-text">{{ 'delivery-note.upload_or_select_file' | translate }}</span>
  </button>
</div>


<div *ngIf="hasFile" class="dn-doc-right">
  <div class="dn-doc-actions">
    <button
      type="button"
      class="dn-more-button"
      (click)="onToggleMenu()"
      [disabled]="isLoading"
    >
      <tui-loader size="xs" *ngIf="isLoading" class="dn-btn-loader"></tui-loader>
      <tui-icon *ngIf="!isLoading" icon="tuiIconMoreVertical" class="dn-more-icon"></tui-icon>
    </button>

    <div class="options-menu" *ngIf="showMenu && menuActions.length > 0" [@fadeInOut]>
      <ng-container *ngFor="let item of menuActions">
        <div *ngIf="item.dividerBefore" class="divider"></div>
        <button
          type="button"
          class="option-item"
          [class.danger]="item.danger"
          [disabled]="isLoading"
          (click)="onMenuAction(item)"
        >
          <tui-icon [icon]="item.icon" class="option-icon"></tui-icon>
          <span>{{ item.labelKey | translate }}</span>
        </button>
      </ng-container>
    </div>

    <div class="options-menu" *ngIf="showMenu && menuActions.length === 0" [@fadeInOut]>
      <button
        type="button"
        class="option-item danger"
        [disabled]="isLoading"
        (click)="onDelete()"
      >
        <tui-icon icon="tuiIconTrash" class="option-icon"></tui-icon>
        <span>{{ 'delivery-note.delete_document' | translate }}</span>
      </button>
    </div>
  </div>
</div>
